import React from "react";
import { authenticatedPostFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import i18n from '../../../i18n';

import {
  Alert,
  Dialog,
  Classes,
  Button,
  H4,
  HTMLSelect,
  InputGroup,
  FormGroup,
  H5,
  Intent,
  Checkbox,
  Radio, RadioGroup
} from "@blueprintjs/core";
import EventSelect from "../../Structure/EventSelector"

export default class EventCounterCreator extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      level: 1,
      title: "",
      events: [],
      success: false,
      error: false,
      ratioEvents: [],
      ratioType: 0,
      isRatio: false
    };
  }

  render() {
    return (
      <div>
        <Dialog
          isOpen={this.state.open}
          style={{ transition: 'none' }}
          onClose={() => this.setState({ open: false })}
        >
          <div className={Classes.DIALOG_BODY}>
            <H4><Trans>add key values</Trans></H4>
            <div>
              <FormGroup
                label={<Trans>title:</Trans>}
                labelFor="title"
              >
                <InputGroup
                  type="text"
                  id="title"
                  value={this.state.title}
                  onChange={(ti) => { this.setState({ title: ti.target.value }); }}
                />
              </FormGroup>
              <HTMLSelect
                options={[{ label: i18n.t("success"), value: 0 }, { label: i18n.t("info"), value: 1 }, { label: i18n.t("warning"), value: 2 }, { label: i18n.t("error"), value: 3 }]}
                onChange={(s) => this.setState({ level: s.target.value })}
              />
              <H5><Trans>monitored events</Trans></H5>
              <div className="flexbox-left">
                <EventSelect value={this.state.events} onSelectionChange={(selection) => this.setState({ events: selection })} />
              </div>
            </div>
            <Checkbox
              icon="percentage"
              checked={this.state.isRatio}
              label={i18n.t("is ratio")}
              onChange={(cb) => {
                this.setState({ isRatio: cb.target.checked });
                if (!cb.target.checked)
                  this.setState({ ratioEvents: [] });
              }}
            />
            {this.state.isRatio ?
              <div>
                <RadioGroup
                  label={i18n.t("of:")}
                  onChange={(rad) => {
                    switch (rad.target.value) {
                      case "0":
                        this.setState({ ratioType: rad.target.value, ratioEvents: [1, 21, 29, 31, 60, 61, 62, 110, 135, 136, 161, 180, 189, 190, 205, 223, 229, 238, 268, 320, 331, 334, 361, 368, 374, 378, 540, 580, 593] });
                        break;
                      case "1":
                        this.setState({ ratioType: rad.target.value, ratioEvents: [2, 3, 26, 30, 32, 68, 69, 76, 77, 78, 111, 137, 138, 162, 181, 191, 206, 215, 217, 224, 225, 321, 230, 239, 260, 266, 267, 269, 330, 332, 335, 362, 363, 369, 375, 379, 541, 542, 582, 585, 586, 594] });
                        break;
                      default:
                        this.setState({ ratioType: rad.target.value, ratioEvents: [] });
                        break;
                    }
                  }}
                  selectedValue={this.state.ratioType}
                >
                  <Radio label={<Trans>entries</Trans>} value="0" />
                  <Radio label={<Trans>exits</Trans>} value="1" />
                  <Radio label={<Trans>a custom selection of events</Trans>} value="2" />
                </RadioGroup>
                <EventSelect value={this.state.ratioEvents} onSelectionChange={(selection) => this.setState({ ratioEvents: selection })} />
              </div>
              : null}
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                icon='undo'
                intent={Intent.DANGER}
                onClick={() => this.setState({ open: false })}
              >
                <Trans>cancel</Trans>
              </Button>
              <Button icon='send-to'
                onClick={() => {
                  authenticatedPostFetch('/keyvalue',
                    { title: this.state.title, events: this.state.events, level: this.state.level },
                    (code, authResponse) => {
                      if (code === 200) {
                        this.props.onCreate();
                        this.setState({ success: true, open: false })
                      }
                      else
                        this.setState({ error: true, open: false });
                    }, () => this.setState({ error: true, open: false }));
                }}
              >
                <Trans>send</Trans>
              </Button>
            </div>
          </div>
        </Dialog>
        <Button icon="add" onClick={() => this.setState({ open: true })} />
        <Alert
          isOpen={this.state.success}
          onClose={() => this.setState({ success: false })}
          onConfirm={() => this.setState({ success: false })}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="success"
          icon="tick"
        >
          <Trans>created successfully</Trans>
        </Alert>
        <Alert
          isOpen={this.state.error}
          onClose={() => this.setState({ error: false })}
          onConfirm={() => this.setState({ error: false })}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="danger"
          icon="error"
        >
          <Trans>error while creating</Trans>
        </Alert>
      </div>);
  }
}